import { render, staticRenderFns } from "./ImmersivePage.vue?vue&type=template&id=f200e310"
import script from "./ImmersivePage.vue?vue&type=script&lang=js"
export * from "./ImmersivePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports